import { Component, h, State, Element, Method } from '@stencil/core';

@Component({
  tag: 'rzf-collapsable',
  styleUrl: 'rzf-collapsable.css',
  shadow: true,
})
export class RzfCollapsable {
  @State() isOpen = false;
  @Element() el: HTMLElement;

  @Method()
  async closeContent() {
    this.isOpen = false;
  }

  handleClick = () => (this.isOpen = !this.isOpen);

  hasFooterSlotContent = () => {
    return this.el.querySelector('[slot="footer"]') !== null;
  };

  render() {
    return (
      <article class="rzf-collapsable">
        <header class="rzf-collapsable__header">
          <div class="rzf-collapsable__title-container">
            <h2 class="rzf-collapsable__title">
              <slot name="title">Title</slot>
            </h2>
            <p class="rzf-collapsable__subtitle">
              <slot name="subtitle">Subtitle</slot>
            </p>
          </div>
          <button
            class={{
              'rzf-collapsable__toggle': true,
              'rzf-collapsable__toggle-icon--uncollapsed': Boolean(this.isOpen),
              'rzf-collapsable__toggle-icon--collapsed': !Boolean(this.isOpen),
            }}
            onClick={this.handleClick}
            aria-expanded={this.isOpen}
          >
            <slot name="toggle">
              <svg
                class={{ 'rzf-collapsable__toggle-icon': true, 'rzf-collapsable__toggle-icon--rotated': this.isOpen }}
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M13 23.7059C18.9127 23.7059 23.7059 18.9127 23.7059 13C23.7059 7.08731 18.9127 2.29412 13 2.29412C7.08731 2.29412 2.29412 7.08731 2.29412 13C2.29412 18.9127 7.08731 23.7059 13 23.7059ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
                  fill="#096739"
                />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2362 19.1176L12.2362 6.88232L13.7656 6.88232L13.7656 19.1176L12.2362 19.1176Z" fill="#096739" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.1181 13.7648L6.88281 13.7648L6.88281 12.2354L19.1181 12.2354L19.1181 13.7648Z" fill="#096739" />
              </svg>
            </slot>
          </button>
        </header>
        <hr class="rzf-collapsable__divider" />
        <section class={{ 'rzf-collapsable__content': true, 'rzf-collapsable__content--hidden': !this.isOpen }} aria-hidden={!this.isOpen}>
          <slot name="content"></slot>
        </section>
        {this.hasFooterSlotContent() && (
          <footer class="rzf-collapsable__footer">
            <slot name="footer"></slot>
          </footer>
        )}
      </article>
    );
  }
}
